import { render, staticRenderFns } from "./TermometriaItens.vue?vue&type=template&id=512f1376&"
import script from "./TermometriaItens.vue?vue&type=script&lang=js&"
export * from "./TermometriaItens.vue?vue&type=script&lang=js&"
import style0 from "./TermometriaItens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports